import { z } from 'zod';
import { FieldSchema } from '../common/field';
import { InitialUIElement } from '../initial-ui-element';

export const TAGS_FIELD_ELEMENT_TYPE = 'tagsfield' as const;
export const TagsFieldElementType = z.literal(TAGS_FIELD_ELEMENT_TYPE);

export const TagsFieldParamsSchema = FieldSchema;

export type TTagsFieldParams = z.infer<typeof TagsFieldParamsSchema>;

export const TagsFieldElementSchema = InitialUIElement.extend({
  element: TagsFieldElementType,
  params: TagsFieldParamsSchema,
  valueDestination: z.string(),
});
